// نظام الترجمة للمشروع
export const translations = {
  ar: {
          // Fixed layer names
          baseLayer: 'الطبقة الأساسية',
          linesLayer: 'طبقة الخطوط',
          textLayer: 'طبقة النصوص',
          measurementsLayer: 'طبقة القياسات',
        measuredBy: 'القائم بالقياس',
        branch: 'الفرع',
        depth: 'العمق (D)',
      // Project Info Section
      projectInfo: 'معلومات المشروع',
      devices: 'الأجهزة',
      generalNote: 'ملاحظة عامة',
      projectDetails: 'تفاصيل المشروع',
      client: 'العميل',
      address: 'العنوان',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      notes: 'ملاحظات',
      deviceName: 'اسم الجهاز',
      deviceType: 'نوع الجهاز',
      addDevice: 'إضافة جهاز',
      removeDevice: 'إزالة الجهاز',
      noDevices: 'لا توجد أجهزة',
    // Navbar
    appTitle: 'تطبيق الرسم المعماري',
    projectManagement: 'المعلومات',
    drawingArea: 'منطقة الرسم',
    exportComplete: 'تصدير كامل',
    exportQuick: 'تصدير سريع',
    exportCompleteDesc: 'تصدير المشروع الحالي (كامل)',
    exportQuickDesc: 'تصدير سريع للمشروع الحالي',
    noActiveProjectToExport: 'لا يوجد مشروع نشط لتصديره.',
    project: 'مشروع',
    page: 'صفحة',
    fileName: 'اسم الملف',
    exportProjectFailed: 'فشل تصدير المشروع',
    quickExportFailed: 'فشل التصدير السريع',
    
    // Drawing Tools
    drawingTools: 'أدوات الرسم',
    line: 'خط',
    rectangle: 'مستطيل',
    circle: 'دائرة',
    dimension: 'قياس',
    angle: 'زاوية',
    customAngle: 'حائط منفرد',
    quadrilateral: 'رباعي',
    text: 'نص',
    baseWall: 'حائط أساسي',
    wall: 'حائط',
    wallThickness: 'سمك الحائط',
    
    // Basic Tools
    basicTools: 'الأدوات الأساسية',
    door: 'باب',
    window: 'نافذة',
    socket: 'مقبس كهربائي',
    switch: 'مفتاح كهربائي',
    airConditioner: 'مكيف',
    kitchen: 'مطبخ',
    bathroom: 'حمام',
    bed: 'سرير',
    table: 'طاولة',
    chair: 'كرسي',
    select: 'تحديد وتحريك',
    moveAll: 'تحريك الكل',
    magnet: 'مغناطيس',
    magnetEnabled: 'مغناطيس مفعل',
    
    // Element Properties
    elementProperties: 'خصائص العنصر',
    dragToMove: 'اسحب هنا لتحريك العنصر',
    type: 'النوع',
    component: 'مكون',
    elementName: 'اسم العنصر',
    enterElementName: 'أدخل اسم العنصر',
    layer: 'الطبقة',
    startPointX: 'نقطة البداية X',
    startPointY: 'نقطة البداية Y',
    endPointX: 'نقطة النهاية X',
    endPointY: 'نقطة النهاية Y',
    length: 'الطول',
    angleDegrees: 'الزاوية (°)',
    positionX: 'الموضع X',
    positionY: 'الموضع Y',
    width: 'العرض',
    height: 'الارتفاع',
    color: 'اللون',
    
    // Colors
    black: 'أسود',
    red: 'أحمر',
    blue: 'أزرق',
    green: 'أخضر',
    yellow: 'أصفر',
    purple: 'بنفسجي',
    orange: 'برتقالي',
    brown: 'بني',
    
    // Elements List
    elementsList: 'قائمة العناصر',
    noElements: 'لا توجد عناصر',
    
    // Buttons
    cancel: 'إلغاء',
    add: 'إضافة',
    create: 'إنشاء',
    save: 'حفظ',
    delete: 'حذف',
    close: 'إغلاق',
    hide: 'إخفاء',
    show: 'إظهار',
    duplicate: 'نسخ',
    
    // Quadrilateral Modal
    enterQuadrilateralData: 'إدخال بيانات الرباعي ABCD',
    sideLengths: 'أطوال الأضلاع',
    sideAB: 'الضلع AB (القاعدة)',
    sideBC: 'الضلع BC',
    sideCD: 'الضلع CD',
    sideDA: 'الضلع DA',
    diagonals: 'أقطار الرباعي',
    note: 'ملاحظة',
    diagonalNote: 'القطر الأول يربط بين النقطتين A و C، والقطر الثاني يربط بين النقطتين B و D.',
    horizontalBase: 'القاعدة الأفقية',
    sideABNote: 'الضلع AB سيكون دائماً أفقياً (مستقيماً) كقاعدة للرباعي.',
    colors: 'الألوان',
    colorsNote: 'كل ضلع سيُرسم بلون مختلف - AB (أحمر)، BC (أزرق)، CD (أخضر)، DA (برتقالي).',
    
    // Placeholders
    enterLength: 'أدخل الطول بالـ mm',
    enterWidth: 'أدخل العرض بالـ mm',
    enterHeight: 'أدخل الارتفاع بالـ mm',
    enterName: 'الاسم',
    
    // Settings
    settings: 'الإعدادات',
    snapToGrid: 'الالتصاق بالشبكة',
    gridSize: 'حجم الشبكة',
    zoom: 'التكبير',
    coordinates: 'الإحداثيات',
    
    // Layers
    layers: 'الطبقات',
    baseLayer: 'الطبقة الأساسية',
    linesLayer: 'طبقة الخطوط',
    textLayer: 'طبقة النصوص',
    measurementsLayer: 'طبقة القياسات',
    
    // Pages & Walls
    floor: 'أرضية',
    ceiling: 'سقف',
    wall: 'حائط',
    goToFloor: 'انتقل إلى صفحة الأرضية',
    goToCeiling: 'انتقل إلى صفحة السقف',
    addNewWall: 'إضافة حائط جديد',
    currentPage: 'الصفحة الحالية',
    
    // Header Actions
    undo: 'تراجع',
    redo: 'إعادة',
    clear: 'مسح',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    reset: 'إعادة تعيين',
    saveCurrentProject: 'حفظ المشروع الحالي',
    exportCurrentPageSVG: 'تصدير الصفحة الحالية كملف SVG',
    exportSVG: 'تصدير SVG',
    noActiveProject: 'لا يوجد مشروع نشط للحفظ',
    tool: 'الأداة',
    perpendicular: 'خطوط متعامدة',
    addBasicMeasures: 'اضف القياسات الأساسية',
    baseMeasurementsTitle: 'القياسات الأساسية',
    currentMeasurements: 'القياسات الحالية',
    
    // Units
    mm: 'mm',
    degrees: '°',
    
    // Messages
    enterAllFields: 'الرجاء إدخال قيم صحيحة لجميع الحقول',
    mustBeGreaterThanZero: 'يجب أن يكون الطول والعرض أكبر من صفر',
    outsideBaseWall: 'المكون خارج حدود الحائط الأساسي. يرجى التحقق من القياسات والمسافات.',
    calculationError: 'خطأ في الحساب. يرجى التحقق من القيم المدخلة.',
    enterAllValues: 'يرجى إدخال جميع القيم المطلوبة',
    quadrilateralError: 'خطأ في حساب الرباعي. يرجى التحقق من القيم المدخلة.',
    customAngleError: 'خطأ في إنشاء الحائط المنفرد. يرجى التحقق من القيم المدخلة.',
    mustDrawBaseWall: 'يجب رسم الحائط الأساسي أولاً',
    baseWallAlreadyDrawn: 'تم رسم الحائط الأساسي بالفعل. لتغييره، احذفه أولاً من قائمة العناصر.',
    projectSavedSuccess: 'تم حفظ المشروع بنجاح',
    enterNameAndModel: 'يرجى إدخال الاسم والموديل على الأقل',
    
    // Angle Directions
    horizontalRightUp: 'أفقي يمين - أعلى ↗',
    horizontalRightDown: 'أفقي يمين - أسفل ↘',
    horizontalLeftUp: 'أفقي يسار - أعلى ↖',
    horizontalLeftDown: 'أفقي يسار - أسفل ↙',
    
    // Projects Page
    projectsCenter: 'مركز إدارة المشاريع',
    createManageExport: 'أنشئ وادر وصدّر مشاريعك بسهولة',
    howToUse: 'كيفية الاستخدام:',
    newProjectDesc: 'إنشاء مشروع جديد بلوحة رسم فارغة',
    loadDesc: 'فتح مشروع محفوظ والعمل عليه',
    saveDesc: 'حفظ التقدم الحالي في المشروع',
    exportDesc: 'تصدير المشروع كملف .cadproject للمشاركة أو النسخ الاحتياطي',
    importDesc: 'استيراد مشروع من ملف .cadproject',
    deleteDesc: 'حذف مشروع نهائياً من النظام',
    systemFeatures: 'ميزات النظام:',
    autoSave: 'حفظ تلقائي لجميع البيانات والأشكال المرسومة',
    multiplePages: 'دعم صفحات متعددة (أرضية، سقف، جدران)',
    advancedLayers: 'نظام طبقات متقدم',
    saveProjectSettings: 'حفظ إعدادات المشروع ومعلومات العميل',
    exportImportJSON: 'تصدير واستيراد المشاريع بصيغة JSON',
    easyInterface: 'واجهة سهلة الاستخدام باللغة العربية',
    
    // Project Manager
    projectsManagement: 'معلومات',
    newProject: 'مشروع جديد',
    importProject: 'استيراد مشروع',
    noSavedProjects: 'لا توجد مشاريع محفوظة',
    createFirstProject: 'إنشاء أول مشروع',
    active: 'نشط',
    version: 'الإصدار',
    createdAt: 'تم الإنشاء',
    lastModified: 'آخر تعديل',
    createNewProject: 'إنشاء مشروع جديد',
    projectName: 'اسم المشروع',
    enterProjectName: 'أدخل اسم المشروع',
    importProjectTitle: 'استيراد مشروع',
    chooseProjectFile: 'اختر ملف المشروع (.cadproject)',
    importNote: 'يمكنك استيراد ملفات المشاريع بامتداد .cadproject أو .json',
    closeModal: 'إغلاق',
    enterProjectNameAlert: 'يرجى إدخال اسم للمشروع',
    createProjectFailed: 'فشل في إنشاء المشروع',
    noProjectData: 'لا توجد بيانات للمشروع المحدد',
    loadProjectFailed: 'فشل في تحميل المشروع',
    noProjectSelected: 'لا يوجد مشروع محدد للحفظ',
    confirmDelete: 'هل أنت متأكد من حذف المشروع',
    deleteProjectFailed: 'فشل في حذف المشروع',
    importSuccess: 'تم استيراد المشروع بنجاح!',
    importFailed: 'فشل في استيراد المشروع',
    importType: 'النوع',
    notSpecified: 'غير محدد'
    ,
    // Sidebar Quadrilateral Tool
    drawQuadrilateralTitle: 'رسم المضلع الرباعي',
    shapeType: 'نوع الشكل',
    shapeCustom: 'مخصص',
    shapeRectangle: 'مستطيل',
    shapeSquare: 'مربع',
    shapeParallelogram: 'متوازي أضلاع',
    sidesMeasurementsPx: 'قياسات الأضلاع (بالبكسل)',
    sideA_label: 'الضلع أ:',
    sideB_label: 'الضلع ب:',
    sideC_label: 'الضلع ج:',
    sideD_label: 'الضلع د:',
    enterLengthGeneric: 'أدخل الطول',
    baseAnglesDegrees: 'زوايا القاعدة (بالدرجات)',
    angleA_leftBase: 'الزاوية أ (قاعدة يسار):',
    angleB_rightBase: 'الزاوية ب (قاعدة يمين):',
    degreePlaceholder: 'درجة',
    anglesAutoNote: 'الزوايا ج و د ستحسب تلقائياً (ج = أ، د = ب)',
    controlTools: 'أدوات التحكم',
    drawPolygon: 'رسم المضلع',
    reset: 'إعادة تعيين',
    clearAll: 'مسح الكل',
    instructions: 'التعليمات',
    instrSelectShape: 'اختر نوع الشكل المطلوب',
    instrEnterSides: 'أدخل قياسات الأضلاع أ، ب، ج، د',
    instrEnterAnglesAB: 'أدخل زوايا القاعدة أ و ب فقط',
    instrAnglesAuto: 'الزوايا ج و د ستحسب تلقائياً (ج = أ، د = ب)',
    instrAutoValues: 'القيم ستحسب تلقائياً حسب نوع الشكل',
    instrPressDraw: 'اضغط "رسم المضلع" لإنشاء الشكل',
    instrLabelsAppear: 'ستظهر تسميات الزوايا (أحمر) والأضلاع (أخضر)',
    instrShapeFixed: 'الشكل ثابت غير قابل للتحريك',
    instrOnePolygon: 'يمكن رسم مضلع واحد فقط',
    invalidSides: 'يرجى إدخال قياسات صحيحة لجميع الأضلاع',
    invalidAnglesAB: 'يرجى إدخال قياسات صحيحة للزوايا A و B (بين 0 و 180 درجة)',
    invalidAngleSumPrefix: 'مجموع الزوايا يجب أن يكون 360 درجة. المجموع الحالي:' ,
    switchToEnglish: 'التحويل إلى الإنجليزية',
    switchToArabic: 'التبديل إلى العربية'
    ,
    // Component Specific (advanced wall components)
    wallDoor: 'باب جداري',
    wallWindow: 'نافدة',
    electricity: 'كهرباء',
    water: 'ماء',
    gas: 'غاز',
    duct: 'مجرى',
    bidetSprayer: 'شطاف',
    maintenance: 'صيانة',
    wallDuct: 'مجرى جداري',
    floorDoor: 'باب أرضي',
    componentDataEntry: 'إدخال بيانات'
  },
  
  en: {
          // Fixed layer names
          baseLayer: 'Base Layer',
          linesLayer: 'Lines Layer',
          textLayer: 'Text Layer',
          measurementsLayer: 'Measurements Layer',
        measuredBy: 'Measured By',
        branch: 'Branch',
        depth: 'Depth (D)',
      // Project Info Section
      projectInfo: 'Project Info',
      devices: 'Devices',
      generalNote: 'General Note',
      projectDetails: 'Project Details',
      client: 'Client',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      notes: 'Notes',
      deviceName: 'Device Name',
      deviceType: 'Device Type',
      addDevice: 'Add Device',
      removeDevice: 'Remove Device',
      noDevices: 'No devices',
    // Navbar
    appTitle: 'Architectural Drawing App',
    projectManagement: 'Project Management',
    drawingArea: 'Drawing Area',
    exportComplete: 'Complete Export',
    exportQuick: 'Quick Export',
    exportCompleteDesc: 'Export current project (complete)',
    exportQuickDesc: 'Quick export of current project',
    noActiveProjectToExport: 'No active project to export.',
    project: 'Project',
    page: 'Page',
    fileName: 'File Name',
    exportProjectFailed: 'Project export failed',
    quickExportFailed: 'Quick export failed',
    
    // Drawing Tools
    drawingTools: 'Drawing Tools',
    line: 'Line',
    rectangle: 'Rectangle',
    circle: 'Circle',
    dimension: 'Dimension',
    angle: 'Angle',
    customAngle: 'Single Wall',
    quadrilateral: 'Quadrilateral',
    text: 'Text',
    baseWall: 'Base Wall',
    wall: 'Wall',
    wallThickness: 'Wall Thickness',
    
    // Basic Tools
    basicTools: 'Basic Tools',
    door: 'Door',
    window: 'Window',
    socket: 'Socket',
    switch: 'Switch',
    airConditioner: 'Air Conditioner',
    kitchen: 'Kitchen',
    bathroom: 'Bathroom',
    bed: 'Bed',
    table: 'Table',
    chair: 'Chair',
    select: 'Select & Move',
    moveAll: 'Move All',
    magnet: 'Magnet',
    magnetEnabled: 'Magnet Enabled',
    
    // Element Properties
    elementProperties: 'Element Properties',
    dragToMove: 'Drag here to move element',
    type: 'Type',
    component: 'Component',
    elementName: 'Element Name',
    enterElementName: 'Enter element name',
    layer: 'Layer',
    startPointX: 'Start Point X',
    startPointY: 'Start Point Y',
    endPointX: 'End Point X',
    endPointY: 'End Point Y',
    length: 'Length',
    angleDegrees: 'Angle (°)',
    positionX: 'Position X',
    positionY: 'Position Y',
    width: 'Width',
    height: 'Height',
    color: 'Color',
    
    // Settings
    settings: 'Settings',
    snapToGrid: 'Snap to Grid',
    gridSize: 'Grid Size',
    zoom: 'Zoom',
    coordinates: 'Coordinates',
    
    // Elements List
    elementsList: 'Elements',
    noElements: 'No elements',
    
    // Quadrilateral Modal
    enterQuadrilateralData: 'Enter Quadrilateral ABCD Data',
    sideLengths: 'Side Lengths',
    sideAB: 'Side AB (Base)',
    sideBC: 'Side BC',
    sideCD: 'Side CD',
    sideDA: 'Side DA',
    diagonals: 'Quadrilateral Diagonals',
    diagonal1: 'First Diagonal (AC) mm',
    diagonal2: 'Second Diagonal (BD) mm',
    angleDirection: 'Angle Direction',
    angleMeasurement: 'Angle Measurement',
    firstLine: 'First Line',
    secondLine: 'Second Line',
    name: 'Name',
    thickness: 'Thickness',
    widthMM: 'Width (mm)',
    heightMM: 'Height (mm)',
    distanceFromBottom: 'Distance from Bottom (mm)',
    distanceFromLeft: 'Distance from Left (mm)',
    note: 'Note',
    diagonalNote: 'The first diagonal connects points A and C, the second diagonal connects points B and D.',
    horizontalBase: 'Horizontal Base',
    sideABNote: 'Side AB will always be horizontal (straight) as the base of the quadrilateral.',
    colors: 'Colors',
    colorsNote: 'Each side will be drawn in a different color - AB (red), BC (blue), CD (green), DA (orange).',
    
    // Colors
    black: 'Black',
    red: 'Red',
    blue: 'Blue',
    green: 'Green',
    yellow: 'Yellow',
    purple: 'Purple',
    orange: 'Orange',
    brown: 'Brown',
    
    // Placeholders
    enterLength: 'Enter length in mm',
    enterWidth: 'Enter width in mm',
    enterHeight: 'Enter height in mm',
    enterName: 'Name',
    
    // Layers
    layers: 'Layers',
    baseLayer: 'Base Layer',
    linesLayer: 'Lines Layer',
    textLayer: 'Text Layer',
    measurementsLayer: 'Measurements Layer',
    
    // Pages & Walls
    floor: 'Floor',
    ceiling: 'Ceiling',
    wall: 'Wall',
    goToFloor: 'Go to floor page',
    goToCeiling: 'Go to ceiling page',
    addNewWall: 'Add new wall',
    currentPage: 'Current Page',
    
    // Header Actions
    undo: 'Undo',
    redo: 'Redo',
    clear: 'Clear',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    reset: 'Reset',
    saveCurrentProject: 'Save current project',
    exportCurrentPageSVG: 'Export current page as SVG file',
    exportSVG: 'Export SVG',
    noActiveProject: 'No active project to save',
    tool: 'Tool',
    perpendicular: 'Perpendicular Lines',
    addBasicMeasures: 'Add Basic Measurements',
    baseMeasurementsTitle: 'Base Measurements',
    currentMeasurements: 'Current Measurements',
    
    // Units
    mm: 'mm',
    degrees: '°',
    
    // Messages
    enterAllFields: 'Please enter valid values for all fields',
    mustBeGreaterThanZero: 'Length and width must be greater than zero',
    outsideBaseWall: 'Component is outside the base wall boundaries. Please check measurements and distances.',
    calculationError: 'Calculation error. Please check entered values.',
    enterAllValues: 'Please enter all required values',
    quadrilateralError: 'Error calculating quadrilateral. Please check the entered values.',
    customAngleError: 'Error creating single wall. Please check the entered values.',
    mustDrawBaseWall: 'You must draw the base wall first',
    baseWallAlreadyDrawn: 'Base wall already drawn. To change it, delete it first from the elements list.',
    projectSavedSuccess: 'Project saved successfully',
    enterNameAndModel: 'Please enter at least the name and model',
    
    // Angle Directions
    horizontalRightUp: 'Horizontal Right - Up ↗',
    horizontalRightDown: 'Horizontal Right - Down ↘',
    horizontalLeftUp: 'Horizontal Left - Up ↖',
    horizontalLeftDown: 'Horizontal Left - Down ↙',
    
    // Projects Page
    projectsCenter: 'Project Management Center',
    createManageExport: 'Create, manage, and export your projects easily',
    howToUse: 'How to Use:',
    newProjectDesc: 'Create a new project with a blank drawing canvas',
    loadDesc: 'Open a saved project and work on it',
    saveDesc: 'Save current progress in the project',
    exportDesc: 'Export project as .cadproject file for sharing or backup',
    importDesc: 'Import a project from .cadproject file',
    deleteDesc: 'Permanently delete a project from the system',
    systemFeatures: 'System Features:',
    autoSave: 'Automatic saving of all data and drawn shapes',
    multiplePages: 'Support for multiple pages (floor, ceiling, walls)',
    advancedLayers: 'Advanced layer system',
    saveProjectSettings: 'Save project settings and client information',
    exportImportJSON: 'Export and import projects in JSON format',
    easyInterface: 'User-friendly interface in Arabic',
    
    // Project Manager
    projectsManagement: 'Projects Management',
    newProject: 'New Project',
    importProject: 'Import Project',
    noSavedProjects: 'No saved projects',
    createFirstProject: 'Create first project',
    active: 'Active',
    version: 'Version',
    createdAt: 'Created',
    lastModified: 'Last Modified',
    createNewProject: 'Create New Project',
    projectName: 'Project Name',
    enterProjectName: 'Enter project name',
    importProjectTitle: 'Import Project',
    chooseProjectFile: 'Choose project file (.cadproject)',
    importNote: 'You can import project files with .cadproject or .json extension',
    closeModal: 'Close',
    enterProjectNameAlert: 'Please enter a project name',
    createProjectFailed: 'Failed to create project',
    noProjectData: 'No data available for the selected project',
    loadProjectFailed: 'Failed to load project',
    noProjectSelected: 'No project selected to save',
    confirmDelete: 'Are you sure you want to delete the project',
    deleteProjectFailed: 'Failed to delete project',
    importSuccess: 'Project imported successfully!',
    importFailed: 'Failed to import project',
    importType: 'Type',
    notSpecified: 'Not specified'
    ,
    // Sidebar Quadrilateral Tool
    drawQuadrilateralTitle: 'Draw Quadrilateral',
    shapeType: 'Shape Type',
    shapeCustom: 'Custom',
    shapeRectangle: 'Rectangle',
    shapeSquare: 'Square',
    shapeParallelogram: 'Parallelogram',
    sidesMeasurementsPx: 'Side Measurements (px)',
    sideA_label: 'Side A:',
    sideB_label: 'Side B:',
    sideC_label: 'Side C:',
    sideD_label: 'Side D:',
    enterLengthGeneric: 'Enter length',
    baseAnglesDegrees: 'Base Angles (degrees)',
    angleA_leftBase: 'Angle A (left base):',
    angleB_rightBase: 'Angle B (right base):',
    degreePlaceholder: 'deg',
    anglesAutoNote: 'Angles C & D auto (C = A, D = B)',
    controlTools: 'Controls',
    drawPolygon: 'Draw Polygon',
    reset: 'Reset',
    clearAll: 'Clear All',
    instructions: 'Instructions',
    instrSelectShape: 'Select desired shape type',
    instrEnterSides: 'Enter side lengths A, B, C, D',
    instrEnterAnglesAB: 'Enter only base angles A & B',
    instrAnglesAuto: 'Angles C & D are auto (C = A, D = B)',
    instrAutoValues: 'Values auto-adjust by shape type',
    instrPressDraw: 'Press "Draw Polygon" to create shape',
    instrLabelsAppear: 'Angle labels (red) & sides (green) appear',
    instrShapeFixed: 'Shape is fixed and not movable',
    instrOnePolygon: 'Only one polygon can be drawn',
    invalidSides: 'Please enter valid lengths for all sides',
    invalidAnglesAB: 'Please enter valid angles A & B (0-180°)',
    invalidAngleSumPrefix: 'Total angles must be 360°. Current:',
    switchToEnglish: 'Switch to English',
    switchToArabic: 'Switch to Arabic'
    ,
    // Component Specific (advanced wall components)
    wallDoor: 'Wall Door',
    wallWindow: 'Window',
    electricity: 'Electricity',
    water: 'Water',
    gas: 'Gas',
    duct: 'Duct',
    bidetSprayer: 'Bidet Sprayer',
    maintenance: 'Maintenance',
    wallDuct: 'Wall Duct',
    floorDoor: 'Floor Door',
    componentDataEntry: 'Enter Component Data'
  }
};

// دالة للحصول على الترجمة
export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['ar'][key] || key;
};

// دالة للحصول على كل الترجمات للغة معينة
export const getLanguageTranslations = (lang) => {
  return translations[lang] || translations['ar'];
};
